<template>
  <div>
    <template v-if="isBatch">
      <div v-if="$has('FWS-KJSH-DDSK-TGBH')">
        <el-button
          type="success"
          icon="el-icon-success"
          :size="formSize"
          :disabled="multipleSelection.length === 0"
          @click="handleOperateState(true,1)"
          v-track
          trackCode='approvalPaymentApplyList-5'
        >
          批量通过
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-delete-solid"
          :size="formSize"
          :disabled="multipleSelection.length===0"
          @click="handleOperateState(true,2)"
          v-track
          trackCode='approvalPaymentApplyList-5'
        >
          批量驳回
        </el-button>
      </div>
    </template>
    <template v-else>
      <div v-if="[1, '1'].includes(current.status) && $has('FWS-KJSH-DDSK-TGBH')">
        <el-button
          class="table-button table-button-success"
          icon="el-icon-success"
          @click="handleOperateState(false, 1, current)"
          v-track
          trackCode='approvalPaymentApplyList-4'
        >通过</el-button>
        <el-button
          class="table-button table-button-danger"
          icon="el-icon-delete-solid"
          @click="handleOperateState(false, 2, current)"
          v-track
          trackCode='approvalPaymentApplyList-4'
        >驳回</el-button>
      </div>
    </template>
    <!-- 确认/取消确认弹窗 -->
    <jr-operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="auditObj"
      :text-config.sync="textConfig"
      :totalInfo.sync="totalInfo"
      :params="{cancelRemark:'rejectReason'}"
      :loading="submitLoading"
      @submit="opStateResultsSubmit"
    />
  </div>
</template>

<script>
import { approvalOrder } from '@/api/approval/order';

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '1',
    },
    multipleSelection: {
      type: Array,
      default: () => ([]),
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      auditObj: {}, // 审核对象
      textConfig: {}, // 弹窗页面提示文案
      isOperateStateShow: false, // 确认/驳回弹窗
      submitLoading: false,
      // 批量操作合并信息
      totalInfo: {
        totalNum: 0, // 合计数量
      },
    };
  },
  methods: {
    // 批量确认/驳回操作
    handleOperateState(batch, operation, row = {}) {
      const flagList = (this.multipleSelection || []).map((item) => item.typeDesc);
      if (new Set(flagList).size > 1) {
        this.$message.warning('选中的数据中有不同申请类型的审核订单！');
        return;
      }

      const applyNos = (this.multipleSelection || []).map((item) => item.applyNo);
      this.auditObj = {
        applyNos: batch ? applyNos : [row?.applyNo],
        operation, // 操作：1、通过 2、驳回
        rejectReason: '', // 驳回原因，驳回时必传
      };
      let list = {
        1: {
          title: '审核通过确认',
          messageTip: `是否通过该笔${row.typeDesc}的申请？`,
          isPass: true,
        },
        2: {
          title: '审核驳回',
          messageTip: '请填写驳回该笔申请的原因',
          isPass: false,
          required: true,
        },
      };
      if (batch) {
        list = {
          1: {
            title: '批量审核通过确认',
            messageTip: '是否批量通过所有被选中的订单申请？',
            isPass: true,
            isTotal: true,
          },
          2: {
            title: '批量审核驳回',
            messageTip: '批量驳回原因',
            isPass: false,
            isTotal: true,
            required: true,
          },
        };
        this.totalInfo = {
          totalNum: this.multipleSelection.length ?? 0, // 合计数量
        };
      }
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    // 审核列表-批量审核操作+审核操作请求接口
    opStateResultsSubmit(params) {
      this.submitLoading = true;
      approvalOrder(params).then((res) => {
        console.log(res);
        this.submitLoading = false;
        this.$message({
          message: '操作成功！',
          type: 'success',
        });
        this.isOperateStateShow = false;
        this.$emit('success');
      }).catch(() => {
        this.submitLoading = false;
      });
    },
  },
};
</script>
